import React from "react";
import { useEffect,useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Navigate, useNavigate, useOutletContext } from "react-router-dom";
import { useSelector } from "react-redux";
import MbpAthnUi from "Utils/MbpAthn";
import MgpStore from "Stores/Store";
import MembIdntMthdChngApi from "Apis/MembIdntMthdChngApi";
import MbpAthnRsltVrfRqstApi from "Apis/MbpAthnRsltVrfRqstApi";
import ApiResultModal from "Components/ApiResultModal";



const MembIdntMthdReAthnUi = () => {
    const langData:any = useOutletContext();
    const navigate = useNavigate();
    const idntMthdCd = useSelector((state: any) => state.IdntMthdCdState?.IdntMthdCd);
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null);

    const openResultModal = (message: string, onClose?: () => void) => {
        setResultModalMessage(message);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (action) action();
    };

    
    useEffect(()=>{
        function kmcRespFunc (kmcApiTknrslt:string,kmcApiCertNumrslt:string){
            MbpAthnRsltVrfRqstApi(kmcApiTknrslt,kmcApiCertNumrslt)
            .then((resp) => {
                switch(resp.apiHdr.code) {
                    case "ATHN0000":
                        openResultModal("변경이 완료되었습니다.", () => navigate("/Mypage"));                    
                    break;
                    case "ATHN2312":
                        openResultModal("본인 인증 정보가 일치하지 않습니다. 다시 시도해주세요.");                    
                    break;
                    default:
                        openResultModal((langData&&langData.GLB_ATHN_FAIL_DESC_00) + resp.apiHdr.code);
                    break;
                }
            });
            
        }
        window.kmcRespFunc = kmcRespFunc;
        },[])
    return(
        <>
        <ApiResultModal
            open={resultModalOpen}
            message={resultModalMessage}
            onClose={closeResultModal}
confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
        />
        <Helmet>
            <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.MYPAGE_MENU_MBPNUM_CHNG_BTN_00}`}</title>
        </Helmet>
        <div className="container1300 BgW pb200">
            <div className="myPageSubTitlWrap">
                <p className="myPageCtxtTitl">{langData&&langData.MYPAGE_MENU_MBPNUM_CHNG_BTN_00}</p>
                {/* 휴대폰 변경 */}
                
            </div>
            <div className="myPageSubCtxtWrap">
                <img className="otpImg" src={process.env.PUBLIC_URL+"/images/Mypage/OtpIcon.png"} alt="" />
                <p className="myPageCtxtTitl myPageEmlChngTitl">{langData&&langData.MYPAGE_MENU_MBPNUM_CHNG_BTN_00}</p>
                <p className="activeText myPageEmlChngActiveText">{langData&&langData.MYPAGE_MENU_MBPNUM_CHNG_DESC_00}</p>                            
                <div className="myPageEmlChngMbpAthn">
                    <MbpAthnUi athnPrpsCd={"MBP_CHNG"} AthnTxt={langData&&langData.COMM_MAIN_ATHN_MAIN_BTN_00}/>
                </div>
            </div> 
        </div>
        </>
    )
}

export default MembIdntMthdReAthnUi;